import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { format } from 'date-fns';

export const LastUpdated: FC<{
  time: string;
  name: string;
}> = ({
  time, name,
}) => (
  <Typography variant="caption">
    Sist endret
    {' '}
    {format(new Date(time), "dd.MM.yyyy 'kl.' HH:mm")}
    {` av ${name}`}
  </Typography>
);
